<app-filter-button
  [filterGroups]="filterGroup"
  (applyFilter)="onFilter($event)">
</app-filter-button>
